/**
 * Vælger oplæsningsstemme ud fra forfatter/kokkens fornavn.
 * Hvis navnet genkendes som kvindeligt, bruges Mia (female), ellers Jesper (male).
 * Det sikrer at citater, digte og opskrifter læses op af en stemme der matcher
 * kønnet på det menneske der har skrevet/skabt indholdet.
 */

const FEMALE_FIRST_NAMES = new Set([
  // Dansk/skandinavisk, ofte forekommende i Flâneriets indhold
  "mia", "inger", "tove", "marie", "karen", "anna", "anne", "ida", "emma", "laura",
  "sara", "caroline", "sofie", "sophie", "johanne", "lise", "mette", "hanne", "pia",
  "gitte", "susanne", "marianne", "louise", "camilla", "lotte", "tina", "sanne",
  "lene", "bente", "rikke", "helle", "ulla", "kirsten", "jette", "grethe", "ellen",
  "margrethe", "dagmar", "agnes", "astrid", "bodil", "erika", "gerda", "gudrun",
  "hilda", "ilse", "johanna", "klara", "lone", "maren", "nanna", "olga", "ruth",
  "sigrid", "signe", "thea", "vibeke", "yrsa", "alma", "astrid", "bjørk", "elin",
  "freja", "gry", "hedvig", "iris", "jonna", "kaja", "lærke", "magdalene", "naja",
  "ophelia", "petra", "ronja", "stine", "trine", "urda", "viktoria", "wilma",
  // Internationale kvindenavn ofte set i citater/litteratur
  "emily", "jane", "virginia", "simone", "sylvia", "mary", "elizabeth", "catherine",
  "kate", "charlotte", "emilie", "george", "sand", "colette", "anaïs", "anais",
  "dorothy", "edith", "frida", "gabriela", "gabrielle", "hannah", "helen", "iris",
  "isabel", "isabella", "julia", "juliet", "katie", "lily", "louisa", "lucy",
  "madeleine", "margaret", "martha", "naomi", "nina", "olivia", "paula", "rachel",
  "rebecca", "rosa", "rose", "sarah", "sophia", "victoria", "vivian", "willa",
  "zora", "audre", "maya", "toni", "flannery", "joan", "anne-marie", "annemarie",
]);

function firstName(name: string): string {
  return name
    .split(/[\s\-––]+/)[0]
    .replace(/[^a-zæøåA-ZÆØÅ]/g, "")
    .toLowerCase();
}

export function voiceForAuthor(author?: string | null): "male" | "female" {
  if (!author) return "male";
  const name = firstName(author);
  return FEMALE_FIRST_NAMES.has(name) ? "female" : "male";
}
